import { inventoryTicketName } from "@/utils/inventoryImage";

const STORAGE_KEY = "pos_last_ticket";

export function formatTicketMoney(value) {
  const n = Number(value) || 0;
  return new Intl.NumberFormat("es-CO", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
}

export function formatTicketMoneyWithSymbol(value) {
  return `$ ${formatTicketMoney(value)}`;
}

export function formatTicketDate(dateInput) {
  const d = dateInput ? new Date(dateInput) : new Date();
  return d.toLocaleDateString("es-CO", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export function buildInvoiceNumber(remissionId) {
  return `FV${String(remissionId).padStart(8, "0")}`;
}

export function savePosTicketData(payload) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
}

export function loadPosTicketData(remissionId = null) {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (remissionId != null && String(data.remissionId) !== String(remissionId)) {
      return null;
    }
    return data;
  } catch {
    return null;
  }
}

export function resolveCompanyLogoUrl(company = {}) {
  const base =
    process.env.VUE_APP_API_IMAGE_URL ||
    process.env.VUE_APP_API_BASE_URL ||
    "";
  const path = company.logo_path || company.logo_path_dark;
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  const normalizedBase = String(base).replace(/\/$/, "");
  const normalizedPath = String(path).replace(/^\//, "");
  return `${normalizedBase}/${normalizedPath}`;
}

export function mergeTicketCompany(ticket, company = {}) {
  if (!ticket) return ticket;
  return {
    ...ticket,
    company: {
      company_name: company.company_name ?? ticket.company?.company_name ?? "",
      description: company.description ?? ticket.company?.description ?? "",
      phone: company.phone ?? ticket.company?.phone ?? "",
      address: company.address ?? ticket.company?.address ?? "",
      email: company.email ?? ticket.company?.email ?? "",
      logo_path: company.logo_path ?? ticket.company?.logo_path ?? "",
      logo_path_dark: company.logo_path_dark ?? ticket.company?.logo_path_dark ?? "",
    },
  };
}

export function buildTicketFromRemission(remission, details, company = {}) {
  const items = (details || []).map((detail) => {
    const inv = detail.inventory;
    const model = detail.model;
    return {
      name: inv ? inventoryTicketName(inv) : model?.name || "Producto",
      ref: inv?.ref || null,
      quantity: detail.quantity,
      unitPrice: detail.price,
      total: detail.total ?? Number(detail.quantity) * Number(detail.price),
    };
  });

  const total = items.reduce((sum, i) => sum + Number(i.total || 0), 0);
  const articlesCount = items.reduce((sum, i) => sum + Number(i.quantity || 0), 0);

  return {
    remissionId: remission.id,
    invoiceNo: buildInvoiceNumber(remission.id),
    dateFormatted: formatTicketDate(remission.created_at),
    client: {
      id: remission.id,
      name: remission.name,
      document_type: remission.document_type || "CC",
      document: remission.document || String(remission.id),
    },
    items,
    subtotal: total,
    total,
    received: total,
    change: 0,
    paymentMethod: "CONTADO",
    articlesCount,
    itemsCount: items.length,
    seller: String(remission.seller?.name || remission.user?.name || "LOCAL").toUpperCase(),
    company: {
      company_name: company.company_name || "",
      description: company.description || "",
      phone: company.phone || "",
      address: company.address || "",
      email: company.email || "",
      logo_path: company.logo_path || "",
      logo_path_dark: company.logo_path_dark || "",
    },
  };
}

export function openPosTicketWindow(router, remissionId) {
  const route = router.resolve({
    name: "POS Ticket",
    query: { id: String(remissionId) },
  });
  window.open(route.href, "_blank");
}
